// 未登录状态下的头部
<template>
  <span class="consult-login" @click="goLogin"><i class="el-icon-user" style="font-size: 16px; margin-right: 5px"></i>登录</span>
</template>

<script>
export default {
  methods: {
    goLogin () {
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.consult-login {
  display: inline-block;
  height: 60px;
  line-height: 60px;
  color: #f1f1f1;
  float: right;
  cursor: pointer;
  margin-left: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/buttonLogin.vue